import { createClient } from '@supabase/supabase-js';

// As variáveis de ambiente devem ser configuradas no seu ambiente de hospedagem (Vercel/Netlify)
// e no .env.local para desenvolvimento.
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error("Supabase URL or Anon Key is missing. Check your .env.local file.");
}

export const supabase = createClient(supabaseUrl!, supabaseAnonKey!);